const preloadImage = (src, timeoutMs = 3500) => {
  if (!src) return Promise.resolve();

  return new Promise((resolve) => {
    const image = new Image();
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      window.clearTimeout(timeout);
      resolve();
    };
    const timeout = window.setTimeout(finish, timeoutMs);
    image.onload = finish;
    image.onerror = finish;
    image.src = src;
  });
};

export default preloadImage;
